<template>
  <v-row>
    <v-col
        v-for="item in equipmentGroups"
        :key="item"
        cols="12"
        md="4"
        lg="3"
    >
      <v-row :no-gutters="true">
        <p class="text-subtitle-1 font-weight-medium">{{ item.englishName }}</p>
      </v-row>
      <v-row
          v-for="subItem in item.equipments"
          :key="subItem"
          :no-gutters="true"
      >
        <p>{{ subItem.englishName }}</p>
        <v-icon
            :color="subItem.isExists ? 'success' : 'error'"
            icon="mdi-circle-medium"
        />
      </v-row>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: "SpecificationDetails",
  props: {
    equipmentGroups: Object
  }
}
</script>

<style scoped>

</style>